<!-- maps-infos-component -->

<!-- infos-title -->
<div *ngIf="!hideHeader" class="component-header">
    <span style="flex-grow:1; flex-shrink:1; flex-basis:content;"></span>
    <span class="header-title">{{'MAPS.INFOS.TITLE_TEXT' | translate}}</span>
    <span style="flex-grow:1; flex-shrink:1; flex-basis:content;"></span>
    <!-- close -->
    <div class="btn-close">
        <img src="./assets/icons/close.svg" alt="" title="{{'MAPS.GEN.BACK_ICON_T' | translate}}"
            (click)="onCloseClick()">
    </div>
</div>
<hr *ngIf="!hideHeader" style="margin-top:0.2rem;margin-bottom:0.5rem;">

<div class="button-row">
    <button mat-raised-button color="primary" [class.active]="infoType==='about'" style="margin-left:0.5rem;"
        (click)="infoType='about'">{{'MAPS.INFOS.TAB-ABOUT_TITLE' | translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='faq'" style="margin-left:0.5rem;"
        (click)="infoType='faq'">{{'MAPS.INFOS.TAB-FAQ_TITLE' | translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='privacy-policy'" style="margin-left:0.5rem;"
        (click)="infoType='privacy-policy'">{{'MAPS.INFOS.TAB-PRIVACY-POLICY_TITLE' |
        translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='terms-of-use'" style="margin-left:0.5rem;"
        (click)="infoType='terms-of-use'">{{'MAPS.INFOS.TAB-TERMS-OF-USE_TITLE' | translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='feedback'" style="margin-left:0.5rem;"
        (click)="infoType='feedback'">{{'MAPS.INFOS.TAB-FEEDBACK_TITLE' | translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='contact'" style="margin-left:0.5rem;"
        (click)="infoType='contact'">{{'MAPS.INFOS.TAB-CONTACT_TITLE' | translate}}</button>
    <button mat-raised-button color="primary" [class.active]="infoType==='apps'" style="margin-left:0.5rem;"
        (click)="infoType='apps'">{{'MAPS.INFOS.TAB-MORE-APPS_TITLE' | translate}}</button>
</div>
<hr>

<div #infoDlg *ngIf="true" class="component-content">
    <!-- about -->
    <div *ngIf="infoType=== 'about'">
        <app-info-about-component [languageCode]="languageCode"></app-info-about-component>
    </div>

    <!-- faq -->
    <div *ngIf="infoType=== 'faq'">
        <app-info-faq-component [languageCode]="languageCode" [activate]="activateFaq"></app-info-faq-component>
    </div>

    <!-- privacy-policy -->
    <div *ngIf="infoType=== 'privacy-policy'">
        <app-info-privacypolicy-component [languageCode]="languageCode"></app-info-privacypolicy-component>
    </div>

    <div *ngIf="infoType=== 'terms-of-use'">
        <app-info-termsofuse-component [languageCode]="languageCode"></app-info-termsofuse-component>
    </div>

    <!-- feedback -->
    <div *ngIf="infoType=== 'feedback'">
        <app-footer-bugs-component [languageCode]="languageCode"></app-footer-bugs-component>
    </div>

    <!-- contact -->
    <div *ngIf="infoType=== 'contact'">
        <app-info-impressum-component [languageCode]="languageCode"></app-info-impressum-component>
    </div>

    <div *ngIf="infoType=== 'apps'">
        <app-info-other-apps-component [languageCode]="languageCode"></app-info-other-apps-component>
    </div>



    <div *ngIf="false" [class.from-router]="calledFromRouter">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex"
            (selectedTabChange)="onTabChange($event)">

            <!-- about -->
            <mat-tab label="{{'MAPS.INFOS.TAB-ABOUT_TITLE' | translate}}">
                <app-info-about-component [languageCode]="languageCode"></app-info-about-component>
            </mat-tab>

            <!-- faq -->
            <mat-tab label="{{'MAPS.INFOS.TAB-FAQ_TITLE' | translate}}">
                <app-info-faq-component [languageCode]="languageCode" [activate]="activateFaq"></app-info-faq-component>
            </mat-tab>

            <!-- privacypolicy -->
            <mat-tab label="{{'MAPS.INFOS.TAB-PRIVACY-POLICY_TITLE' | translate}}">
                <app-info-privacypolicy-component [languageCode]="languageCode"></app-info-privacypolicy-component>
            </mat-tab>

            <!-- termsofuse -->
            <mat-tab label="{{'MAPS.INFOS.TAB-TERMS-OF-USE_TITLE' | translate}}">
                <app-info-termsofuse-component [languageCode]="languageCode"></app-info-termsofuse-component>
            </mat-tab>

            <!-- feedback -->
            <mat-tab label="{{'MAPS.INFOS.TAB-FEEDBACK_TITLE' | translate}}">
                <app-footer-bugs-component [languageCode]="languageCode"></app-footer-bugs-component>
            </mat-tab>

            <!-- contact -->
            <mat-tab label="{{'MAPS.INFOS.TAB-CONTACT_TITLE' | translate}}">
                <app-info-impressum-component [languageCode]="languageCode"></app-info-impressum-component>
            </mat-tab>

            <!-- other apps -->
            <mat-tab label="{{'MAPS.INFOS.TAB-MORE-APPS_TITLE' | translate}}">
                <app-info-other-apps-component [languageCode]="languageCode"></app-info-other-apps-component>
            </mat-tab>

        </mat-tab-group>

    </div>


</div>